/*
 *
 * TransactionTime constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/TransactionTime';

export const DEFAULT_ACTION = 'app/TransactionTime/DEFAULT_ACTION';

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const SET_TRANSACTION_COMPLETE_TIME = `${BASE_ACTION_CONSTANT}/SET_TRANSACTION_COMPLETE_TIME`;

export const GET_TRANSACTION_COMPLETE_TIME = `${BASE_ACTION_CONSTANT}/GET_TRANSACTION_COMPLETE_TIME`;

export const SET_TRANSACTION_COMPLETE_TIME_URL = {
  url: '/router/merchants/$merchantId$/config',
  method: 'POST',
};

export const GET_TRANSACTION_COMPLETE_TIME_URL = {
  url: '/router/merchants/$merchantId$/config/TTL',
  method: 'GET',
};
